var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, styled, useTheme } from '@mui/material';
import { useTrack, AudioTrack, VideoTrack } from 'hx-twilio-video';
import { BsFillMicMuteFill } from 'react-icons/bs';
import { grey } from '@mui/material/colors';
export var Participant = function (_a) {
    var participant = _a.participant, _b = _a.fallback, fallback = _b === void 0 ? _jsx("span", { children: "loading..." }) : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.flipVideo, flipVideo = _d === void 0 ? false : _d, _e = _a.voiceOnly, voiceOnly = _e === void 0 ? false : _e;
    var _f = useTrack({
        participant: participant,
    }), videoOn = _f.videoOn, audioOn = _f.audioOn, videoTrack = _f.videoTrack, audioTrack = _f.audioTrack;
    if (!videoTrack || !audioTrack)
        return fallback;
    return (_jsxs(Wrapper, __assign({ className: className }, { children: [voiceOnly || !videoOn ? (_jsx(CameraOffOverlay, {})) : (_jsx(VideoTrack, { track: videoTrack, flipVideo: flipVideo })), audioOn ? _jsx(AudioTrack, { track: audioTrack }) : _jsx(MicrophoneOffOverlay, {})] })));
};
export default Participant;
var Wrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        overflow: 'hidden',
        height: '100%',
        background: theme.palette.common.black,
    });
});
var CameraOffOverlay = function () {
    return (_jsx("div", __assign({ style: {
            position: 'absolute',
            inset: '0',
            backgroundColor: grey[600],
            display: 'grid',
            placeItems: 'center',
        } }, { children: _jsx(Avatar, {}) })));
};
var MicrophoneOffOverlay = function () {
    var theme = useTheme();
    return (_jsx("div", __assign({ style: {
            position: 'absolute',
            inset: '0',
            display: 'grid',
            alignItems: 'start',
            justifyContent: 'start',
        } }, { children: _jsx("div", __assign({ style: {
                backgroundColor: grey[800],
                borderRadius: '50%',
                padding: '0.5rem',
                margin: '0.5rem',
            } }, { children: _jsx(BsFillMicMuteFill, { color: theme.palette.common.white, size: "1rem" }) })) })));
};
